module.exports = __webpack_public_path__ + "img/cut-line.a4984c9c.png";